import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDashboard } from "../../store/userSlice";

const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString();
};

const DEFAULT_AVATAR = "/assets/images/icon/user-2.svg";

const resolveAvatarUrl = (value) => {
  if (!value) return DEFAULT_AVATAR;
  if (/^https?:\/\//i.test(value)) return value;
  const base = process.env.REACT_APP_SERVER_ADDRESS || window.location.origin || "";
  return `${base}${value.startsWith("/") ? value : `/${value}`}`;
};

const UserDashboard = () => {
  const dispatch = useDispatch();
  const { dashboard, profile, status } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchUserDashboard());
  }, [dispatch]);

  const dashboardProfile = dashboard?.profile || {};
  const counters = dashboard?.counters || {};
  const jobs = dashboard?.recentAppliedJobs || [];
  const avatarSrc =
    resolveAvatarUrl(profile?.avatar || dashboardProfile?.avatar);
  const displayName =
    `${profile?.firstName || dashboardProfile?.firstName || ""} ${
      profile?.lastName || dashboardProfile?.lastName || ""
    }`.trim() || "User";

  return (
    <div className="dashboard-inner">
      <div className="author-area">
        <div className="author-img">
          <img src={avatarSrc} alt="" />
        </div>
        <div className="author-content">
          <span>Hello, I&apos;m</span>
          <h4>{displayName}</h4>
        </div>
      </div>

      <div className="counter-area">
        <div className="row g-lg-4 g-md-5 gy-5 justify-content-center">
          <div className="col-lg-3 col-sm-6">
            <div className="counter-single">
              <div className="coundown">
                <p>Total Applied</p>
                <h3>{counters.totalApplied || 0}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="counter-single two">
              <div className="coundown">
                <p>Saved Jobs</p>
                <h3>{counters.savedJobs || 0}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="counter-single three">
              <div className="coundown">
                <p>Messages</p>
                <h3>{counters.messageCount || 0}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="counter-single four">
              <div className="coundown">
                <p>Profile Views</p>
                <h3>{counters.profileViews || 0}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table-wrapper mt-4">
        <h5 className="title">Current Applied Jobs:</h5>
        {status === "loading" ? (
          <p>Loading dashboard...</p>
        ) : (
          <div className="scroll-table">
            <table className="eg-table table category-table mb-0">
              <thead>
                <tr>
                  <th>Job Title</th>
                  <th>Apply Date</th>
                  <th>Hospital</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {jobs.length === 0 ? (
                  <tr>
                    <td colSpan="4">No applied jobs yet.</td>
                  </tr>
                ) : (
                  jobs.map((job) => (
                    <tr key={job._id}>
                      <td data-label="Job Title">{job.jobTitle}</td>
                      <td data-label="Apply Date">{formatDate(job.applyDate)}</td>
                      <td data-label="Hospital">{job.hospital || "-"}</td>
                      <td data-label="Status">{job.status || "Applied"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDashboard;
